<template>
	<div>
		  <Breadcrumbs main="Staffs" title="Update Staff" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<router-link to="/staffs" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
									<!-- <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
							   	</div>
							</div>
 
							<form  @submit.prevent="updateStaff" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Staff Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="staff_data.name"/>
												<span class="validate-error" v-if="errors.name">
													{{ errors.name[0] }}
												</span>
											</div>
										</div>
									
                                        <div class="col-md-4">
                                            <div class="mb-3">
                                                <label class="control-label">Username<span class="text-danger">*</span></label>
                                                <input class="form-control" type="text" placeholder="" v-model="staff_data.user_name"/>
                                                <span class="validate-error" v-if="errors.user_name">
                                                    {{ errors.user_name[0] }}
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-md-4 form-group">
                                            <label class="control-label">Mobile No.<span class="text-danger">*</span></label>
                                            <input class="form-control" type="number" placeholder="" v-model="staff_data.mobile" @input="restrictMobileInput" minlength="10" maxLength="10"/>
											<span class="validate-error" v-if="errors.mobile">
												{{ errors.mobile[0] }}
											</span>
										</div>

                                        <div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Email<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="staff_data.email"/>
												<span class="validate-error" v-if="errors.email">
													{{ errors.email[0] }}
												</span>
											</div>
										</div>
									</div>

									<div class="row mt-3">
										<div class="col-sm-12">
											<button class="btn btn-success me-2 float-end" type="submit">Save</button>
										</div>
									</div>
	
								</div>
							</form>
						 </div>
					  </div>
				   </div>
				</div>
			 </div>
 
	</div>
 </template>

<script setup>

import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';
import { onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import 'core-js/modules/es.array.includes'; 

const router = useRouter();
const route = useRoute();

const staff_id = route.query.id;
const staff_data = ref({});
const name = ref("");
const mobile = ref("");
const username = ref("");
const email = ref("");
const errors = ref({});

const fetchStaff = () => {

	const params = {
		staff_id: staff_id
	}

	get(routes.StaffDetails, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                staff_data.value = response.data.data;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const updateStaff = () => {

	const formData = new FormData();
	formData.append('staff_id', staff_id);
	formData.append('name', staff_data.value.name);
	formData.append('user_name', staff_data.value.user_name);
	formData.append('mobile', staff_data.value.mobile);
	formData.append('email', staff_data.value.email);

    post(routes.UpdateStaff, formData, false)
		.then((response) => {
			if (response.status === 200) {
                Swal.fire('', response.data.message || 'Staff updated successfully', 'success');
				router.push({ name: 'staffs'});
            } else {
                Swal.fire('', response.data.message || 'Failed to update staff', 'error');
            }
        })
		.catch((error) => {
			if (error.response?.status === 422) {
                errors.value = error.response.data.message;
            } else if (error.response?.status === 500) { 
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});

};

const restrictMobileInput = (event) => {
	// Remove any non-digit characters and limit to 10 digits
	const value = event.target.value.replace(/\D/g, '').slice(0, 10);
	mobile.value = value;
};

onMounted(() => {
	fetchStaff();
});

</script>